export const myCoursesConstants = {
    SUCCESS: 'MY_COURSES_SUCCESS',
    NEW: 'MY_COURSES_NEW',
    UPDATE: 'MY_COURSES_UPDATE',
    CLEAR: 'MY_COURSES_CLEAR'
};